export default function createDebounce(fn: Function, ms: number) {
  let timeoutId: ReturnType<typeof setTimeout>;

  return function debounce(this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
}
